module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: ("maintenance-" + _vm._uid),
    attrs: {
      "id": ("maintenance-" + _vm._uid)
    },
    on: {
      "input": _vm.close
    }
  }, [(_vm.request) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "slot": "trigger"
    },
    on: {
      "click": _vm.open
    },
    slot: "trigger"
  }, [_vm._v("Edit")]) : _c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('h2', [_vm._v("Update intervention request " + _vm._s(_vm.request.id))]), _c('InterventionRequestForm', {
    attrs: {
      "sub-request": _vm.request.linked_intervention_request_id !== null,
      "edit": true
    },
    model: {
      value: (_vm.body),
      callback: function($$v) {
        _vm.body = $$v
      },
      expression: "body"
    }
  }), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.close(false)
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e9ec67e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/EditInterventionRequestReveal.vue
// module id = 2318
// module chunks = 1